"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/destructuring-assignment */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const RefreshControl_1 = require("./RefreshControl");
exports.patchFlatListProps = () => {
    if (react_native_1.Platform.OS !== "web") {
        return;
    }
    try {
        ;
        react_native_1.FlatList.defaultProps = {
            ...react_native_1.FlatList.defaultProps,
            // eslint-disable-next-line react/display-name
            renderScrollComponent: (props) => (react_1.default.createElement(react_native_1.ScrollView, Object.assign({}, props, { refreshControl: react_1.default.createElement(RefreshControl_1.RefreshControl, Object.assign({ refreshing: props.refreshing, onRefresh: props.onRefresh }, { inverted: props.inverted })) }))),
        };
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
var RefreshControl_2 = require("./RefreshControl");
exports.RefreshControl = RefreshControl_2.RefreshControl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVmcmVzaC9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHVEQUF1RDtBQUN2RCw4Q0FBOEM7QUFDOUMsbURBQW1EOzs7OztBQUVuRCxrREFBeUI7QUFDekIsK0NBQTJEO0FBQzNELHFEQUErQztBQUVsQyxRQUFBLGtCQUFrQixHQUFHLEdBQUcsRUFBRTtJQUNuQyxJQUFJLHVCQUFRLENBQUMsRUFBRSxLQUFLLEtBQUssRUFBRTtRQUN2QixPQUFNO0tBQ1Q7SUFFRCxJQUFJO1FBQ0EsQ0FBQztRQUFDLHVCQUFnQixDQUFDLFlBQVksR0FBRztZQUM5QixHQUFJLHVCQUFnQixDQUFDLFlBQVk7WUFDakMsOENBQThDO1lBQzlDLHFCQUFxQixFQUFFLENBQUMsS0FBVSxFQUFFLEVBQUUsQ0FBQyxDQUNuQyw4QkFBQyx5QkFBVSxvQkFDSCxLQUFLLElBQ1QsY0FBYyxFQUNWLDhCQUFDLCtCQUFjLGtCQUNYLFVBQVUsRUFBRSxLQUFLLENBQUMsVUFBVSxFQUM1QixTQUFTLEVBQUUsS0FBSyxDQUFDLFNBQVMsSUFFckIsRUFBQyxRQUFRLEVBQUUsS0FBSyxDQUFDLFFBQVEsRUFBUyxFQUN6QyxJQUVSLENBQ0w7U0FDSixDQUFBO0tBQ0o7SUFBQyxPQUFPLEtBQUssRUFBRTtRQUNaLHNDQUFzQztRQUN0QyxPQUFPLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFBO0tBQ3ZCO0FBQ0wsQ0FBQyxDQUFBO0FBRUQsbURBQStDO0FBQXZDLDBDQUFBLGNBQWMsQ0FBQSJ9